export default __webpack_public_path__ + "static/sharing-pc-e862bac0c204568c1a4c54f4cc6c088b.png";